<template>
  <button class="holding-row" type="button" @click="$emit('select', token)">
    <TokenLogo :src="token.image" :name="token.name" :size="48" />
    <div class="holding-body">
      <p class="holding-name">{{ token.name }}</p>
      <p class="holding-sub">{{ subline }}</p>
    </div>
    <InvIcon name="chevron-right" class="chevron" />
  </button>
</template>

<script>
import TokenLogo from "@/components/invest/TokenLogo.vue";
import InvIcon from "@/components/invest/InvIcon.vue";
import * as inv from "@/utils/invest.js";

export default {
  name: "InvestHoldingRow",
  components: { TokenLogo, InvIcon },
  props: {
    token: { type: Object, required: true },
    currency: { type: String, default: "NGN" },
  },
  emits: ["select"],
  computed: {
    subline() {
      const shares = inv.shareCount(inv.holdingShares(this.token));
      const cash = inv.money(inv.holdingCashValue(this.token), this.currency, 2);
      return `${shares} shares • ${cash}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.holding-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 4px;
  background: transparent;
  border: none;
  text-align: left;
  cursor: pointer;
}

.holding-body {
  flex: 1;
  min-width: 0;
}

.holding-name {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: #001240;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.holding-sub {
  margin: 2px 0 0;
  font-size: 11px;
  color: #8791a7;
}

.chevron {
  flex-shrink: 0;
  font-size: 18px;
  color: #d0d5e0;
}
</style>
